(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* STS Refine (C9): the panel's links carry tag-path state only, because Liquid
     cannot read the query string. Carry any existing query state — sort_by, the
     native Availability/Price facets — across a refine click so the two filter
     surfaces compose instead of clobbering each other. Progressive enhancement:
     without JS the links still filter correctly, they just reset sort. */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sts-refine-link]');
    if (!link || !window.location.search) return;
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    const query = params.toString();
    if (!query) return;
    const target = new URL(link.getAttribute('href'), window.location.origin);
    if (target.search) return;
    target.search = query;
    link.setAttribute('href', target.pathname + target.search);
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
